<template>
  <div class="scroll-hide" :style="brand !== 'COTTI' ? {'background': '#F8F8F8'} : {}">
    <div v-if="!isLoading && scanQrCodeStatusCode === 0" class="ticket">
      <button class="cnt-button" @click.stop="doOpenRule">
        <div v-if="activityData.activityDesc" class="ticket-rule">
          <img class="rule-img" src="@/assets/ticket/rule.png" alt="" />
          <span class="rule-title">活动说明</span>
        </div>
      </button>

     <img v-if="activityData.publicityImg && activityData.publicityImg.url"
            :src="activityData.publicityImg.url" v-show="false" alt=""/>
      <img v-if="activityData.receivingPublicityImg && activityData.receivingPublicityImg.url"
      :src="activityData.receivingPublicityImg.url" v-show="false" alt="" />
      <img v-if="activityData.afterPublicityImg && activityData.afterPublicityImg.url"
      :src="activityData.afterPublicityImg.url" v-show="false" alt="" />

     <img v-if="activityData.publicityImg && activityData.publicityImg.url && !openEnvelope && !isReceived && !closeEnvelope" class="envelope-img" @click="openEnvelopeEvent()"
            :src="activityData.publicityImg.url" alt="" />
      <img v-if="activityData.receivingPublicityImg && activityData.receivingPublicityImg.url && openEnvelope" class="envelope-img"
      :src="activityData.receivingPublicityImg.url" alt="" />
      <img v-if="activityData.afterPublicityImg && activityData.afterPublicityImg.url && closeEnvelope" class="envelope-img" style="z-index: 1000"
      :src="activityData.afterPublicityImg.url" alt="" />

      <div :style="activityData.backgroundImgSecurityZoneHeight ? {top: ((activityData.backgroundImgSecurityZoneHeight - 28) * 2) /200 + 'rem'} : {top:180 + 'px'}" class="coupon" v-if="closeEnvelope">
        <div class="coupon-text" v-if="randomPrize == 1 && activityData.afterPublicityImg && activityData.afterPublicityImg.url">{{ receiveContent }}</div>
        <div class="coupon-name" v-if="randomPrize == 1 && activityData.afterPublicityImg && activityData.afterPublicityImg.url">{{ couponName }}</div>
      </div>
     <div>

        <img v-if="activityData.backgroundImg && activityData.backgroundImg.url" class="ticket-bg-img"
        :src="activityData.backgroundImg.url" alt="" />
     </div>
    <div class="box_ticket">
        <div v-if="activityData.publicityImg && activityData.publicityImg.url" class="publicity-picture">
        </div>
        <div v-else class="publicity-picture" style="height: 310px" />
      </div>
      <div v-if="loading" class="error" :class="brand=='COTTI' ? 'error_bg' : 'error_bg_tc'">
        <div v-if=isErr>
          <img v-if="brand=='COTTI'" class="is_error" src="https://cdn-arch-common-prod.cotticoffee.com/cottih5/cotti-hot-limit.png" alt="" />
          <img v-else class="is_error" src="https://cdn-arch-common-prod.cotticoffee.com/cottih5/tc-hot-limit.png" alt="" />
          <div class="is_err_title">
            <img v-if="brand=='COTTI'" class="is_err_img" src="https://cdn-arch-common-prod.cotticoffee.com/cottih5/cotti-hot-img.png" alt="" />
            <img v-else class="is_err_img" src="https://cdn-arch-common-prod.cotticoffee.com/cottih5/tc-hot-img.png" alt="" />
            <div class="is_err_text"  :class="brand=='COTTI' ? 'error_text' : 'error_text_tc'">活动太火爆！请稍后再试～</div>
          </div>
        </div>


      </div>
      <div v-else-if="activityLost" class="lost">
        <img v-if="brand=='COTTI'" class="lost-img" src="https://cdn-arch-common-prod.cotticoffee.com/cottih5/activity-lost-1.png" alt="" />
        <img v-else class="lost-img" src="https://cdn-arch-common-prod.cotticoffee.com/cottih5/tc-activity-lost.png" alt="" />
        <div class="lost_title">活动走丢了</div>
        <div v-if="brand=='COTTI'" class="lost_text" >来杯咖啡放松下</div>
        <div v-else class="lost_text" >来杯奶茶放松下</div>
      </div>


      <div v-else class="box_ticket" :style="activityData.backgroundImgSecurityZoneHeight ? {top: (activityData.backgroundImgSecurityZoneHeight * 2) /100 + 'rem'} : {top:400 + 'px'}">

        <div v-if="activityData.couponsComponent && activityData.coupons && activityData.coupons.length === 1"
          class="ticket-single" :style="getStyle(activityData.couponsComponent)">
          <div class="single-content" v-for="(coupon, index) in activityData.coupons" :key="index">
            <span class="content-item content-item-price">
              <div style="display: flex; align-items: center">
                <span v-if="coupon.couponType === 1" class="price-unit">￥</span>
                <span v-if="coupon.couponType === 1 || coupon.couponType === 2" class="price-num">
                  {{ coupon.value && Number(coupon.value) }}
                </span>
                <span v-if="coupon.couponType === 2" class="price-unit">折</span>
                <span v-if="coupon.couponType === 3" class="price-name">兑换商品</span>
              </div>
              <span class="name-num">{{ coupon.couponDesc }}</span>
            </span>
            <span class="content-item content-item-name">
              <div class="name-text">{{ coupon.couponName }}</div>
            </span>
            <span class="content-item-type">
              <span v-if="coupon.couponType === 1" class="type-name">立减券</span>
              <span v-if="coupon.couponType === 2" class="type-name">折扣券</span>
              <span v-if="coupon.couponType === 3" class="type-name">兑换券</span>
            </span>
          </div>
        </div>
        <!-- 优惠券 -->
        <div v-if="activityData.couponsComponent && activityData.coupons && activityData.coupons.length > 1"
          class="ticket-multiple" :style="getStyle(activityData.couponsComponent)">
          <div v-if="activityData.couponName" class="multiple-header">{{ activityData.couponName }}</div>
          <div class="multiple-main">
            <div class="multiple-content" v-for="(coupon, index) in activityData.coupons" :key="index">
              <span class="content-item content-item-price">
                <div style="display: flex; align-items: center">
                  <span class="price-unit" v-if="coupon.couponType === 1">￥</span>
                  <span v-if="coupon.couponType === 1 || coupon.couponType === 2" class="price-num">
                    {{ coupon.value && Number(coupon.value) }}
                  </span>
                  <!--一口价券-->
                  <template v-if="coupon.couponType === 62">
                    <span class="price-unit">￥</span>
                    <span class="price-num">{{ coupon.value && Number(coupon.value) }}</span>
                    <span class="price-change-buy">换购</span>
                  </template>
                  <span v-if="coupon.couponType === 2" class="price-unit">折</span>
                  <span v-if="coupon.couponType === 3" class="price-name">兑换商品</span>
                </div>
                <span class="name-num">{{ coupon.couponDesc }}</span>
              </span>
              <span class="content-item content-item-name">
                <div class="name-text">{{ coupon.couponName }}</div>
              </span>
            </div>
          </div>
        </div>

        <div class="unsupport-wrapper" v-if="!isSupport">
          <div>抱歉</div>
          <div class="unsupport-desc">当前门店暂不支持此活动</div>
          <div>感谢您对{{ brandName }}的关注/</div>
        </div>

        <div v-if="isSupport && !phone && (!isReceived || btnDisable) && Number(this.linkTerminal) !== 3 && (!isInMiniApp || !poi) && Number(this.linkTerminal) !== 4"  class="ticket-user" :style="getStyle(activityData.receiveRewardComponent)">
          <div class="user-wrapper">
            <van-field key="mobile" v-model="mobile" type="digit" maxlength="11" placeholder="请输入手机号码" />
          </div>
          <div class="user-wrapper passwd-item">
            <van-field key="code" v-model="smsCode" type="digit" placeholder="请输入验证码" :maxlength="smsCodeMax">
              <template #button>
                <div class="button-warpper">
                  <div v-if="isSmsSend" class="code-action code-action__disabled" v-html="sendBtnText" />
                  <div v-else class="code-action" @click="handleSendSmsCode">
                    {{ sendBtnText }}
                  </div>
                </div>
              </template>
            </van-field>
          </div>
          <div class="user-wrapper privacy">
            <van-radio-group v-model="agree" @change="changeAgree">

              <van-radio name="isClick" checked-color="#A52337" @click.native="isAgree" class="radio">
              <template #icon="props" >
                <img v-if="brand == 'COTTI' && props.checked" src="~@/assets/ticket/agree.png" class="img">
                <img v-else-if="brand !== 'COTTI' && props.checked" src="~@/assets/ticket/agree-tc.png" class="img">
              </template>
                <span class="text">我已认真阅读并同意</span>
                <span class="text click-text" @click.stop="toService()">《用户协议》</span>
                <span class="text">与</span>
                <span class="text click-text" @click.stop="toPrivacy()">《隐私政策》</span>
                </van-radio>
            </van-radio-group>
          </div>
          <div class="captcha-notice" v-if="!!codeTypeData">
            {{ codeTypeData.content }}
          </div>
          <div class="user-action" :style="btnDisable ? {opacity: 0.55} : {}">
            <button class="cnt-button radius" @click="handleSubmitAction" :disabled="btnDisable" >
              <img
                :src="activityData.receiveRewardComponent && activityData.receiveRewardComponent.buttonImgs && activityData.receiveRewardComponent.buttonImgs.length && activityData.receiveRewardComponent.buttonImgs[0].url"
                alt=""/>
            </button>
          </div>
        </div>

        <!-- 我的 -->

        <div v-else-if="(phone == '' || !phone) && (!isReceived || btnDisable) && ((isInMiniApp && poi) || Number(this.linkTerminal) === 3)" class="ticket-receive" :style="getStyle(activityData.receiveRewardComponent)">
        <div class="receive-title">
          <!-- <span class="line" /> -->
          <span class="text">领取到您的 {{ brandName }} 账号</span>
          <!-- <span class="line" /> -->
        </div>
        <div class="receive-action" :style="btnDisable ? {opacity: 0.55} : {}">
          <button class="cnt-button" @click="toPage('packages/common/login/index')">
            <img
              :src="activityData.receiveRewardComponent && activityData.receiveRewardComponent.buttonImgs && activityData.receiveRewardComponent.buttonImgs.length && activityData.receiveRewardComponent.buttonImgs[0].url"
              alt="" />
          </button>
        </div>
        </div>

        <!-- 我的 领券前按钮-->
        <div v-else-if="phone && (!isReceived || btnDisable)" class="ticket-receive" :style="getStyle(activityData.receiveRewardComponent)">
          <div class="receive-title">
            <span class="text">领取到您的 {{ brandName }} 账号</span>
          </div>
          <div class="receive-phone">{{ phone }}</div>
          <div class="receive-action" :style="btnDisable ? {opacity: 0.55} : {}">
            <button class="cnt-button" @click="handleRecieveAction" :disabled="btnDisable" :style="btnDisable ? {opacity: 0.55} : {}">
              <img
                :src="activityData.receiveRewardComponent && activityData.receiveRewardComponent.buttonImgs && activityData.receiveRewardComponent.buttonImgs.length && activityData.receiveRewardComponent.buttonImgs[0].url"
                alt="" />
            </button>
          </div>
        </div>

        <!-- status !== 1 -->
        <div v-if="isReceived && !btnDisable" class="ticket-received" :style="getStyle(activityData.receiveRewardComponent)" >
          <div class="received-title" v-if="frontContentShowResult.couponShowName !== ''">{{frontContentShowResult.contentShowPrefix}}</div>
          <div class="received-new-title" v-else>{{frontContentShowResult.contentShowPrefix}}</div>
            <div class="received-bag" v-if="frontContentShowResult.couponShowName !== ''">{{ frontContentShowResult.couponShowName}}</div>
            <div class="received-phone">
            {{frontContentShowResult.contentShowAfter}}
            </div>

            <!-- 活动已下架or活动已结束跳转 -->
            <div v-if="activityData.status === 3 || activityData.status === 4" class="received-action no-received">
              <button class="cnt-button" @click="goToUrl()">
                <img :src="advertiseUrl" alt="" />
              </button>
            </div>

            <!-- 领券后按钮(status !== 1 3 4) -->
            <div
              v-else-if="activityData.receiveRewardComponent && activityData.receiveRewardComponent.buttonImgs && activityData.receiveRewardComponent.buttonImgs.length > 1 && unReceiveCoupon"
              class="received-action" style="position: relative">
              <button class="cnt-button" @click="handleJumpAction(activityData?.receiveRewardComponent?.jumpLink, activityData?.receiveRewardComponent?.h5UrlJumpType )">
                <img :src="activityData.receiveRewardComponent.buttonImgs[1].url" alt="" />
              </button>
            </div>

        </div>

        <!-- 附近门店 -->
        <div>
          <div v-if="nearbyShopList.length" class="shop-receive">
            <div class="activity-title">{{ popTitle }}</div>
            <div class="activity-desc">{{ copyWriting }}</div>
            <shop-item
              v-for="item in nearbyShopList"
              :key="item.shopMdCode"
              :id="item.shopMdCode"
              :item="item"
              :linkTerminal="linkTerminal"
            />
          </div>
        </div>

        <!-- 看看大家手气 -->
        <div>
          <div v-if="couponRecordList.length > 0" class="shop-receive">
            <div class="activity-title">看看大家手气</div>
            <div class="max-receive">
              <coupon-record
                  v-for="(item, index) in couponRecordList"
                  :key="item.memberId"
                  :id="item.memberId"
                  :item="item"
                  :lastIndex="index == couponRecordList.length - 1"
                />

            </div>
          </div>
          <!-- <div class="shop-receive" v-else-if="!couponRecordList.length && activityData.participationDetails == 1" >
            <div class="no-receive" >
              <img v-if="brand == 'COTTI'" src="@/assets/ticket/no-card.png" alt="" class="img"/>
              <img v-else src="@/assets/ticket/no-card-tc.png" alt="" class="img"/>
              <div class="no-card">WOW~</div>
              <div class="no-card">你是第一个发现这个宝贝的</div>
            </div>
          </div> -->
        </div>

        <div v-if="(Number(this.linkTerminal) === 2) && isInIos">
            <div style="height: 100px"></div>
          </div>
          <div v-else>
            <div style="height: 34px"></div>
          </div>
        </div>

     

      <div class="Special_popup" :style="{ display: modelShow ? 'block' : 'none' }">
        <div class="box activity-status" :class="brand === 'COTTI' ? 'bg' : ''">
          <div v-if="brand === '茶猫'" class="bg-tc-title"></div>
          <div :class="brand == 'COTTI' ? 'bg-cotti' : 'bg1-tc' ">
            <div class="Special_title" :style="brand == 'COTTI' ? {marginTop: '174px'} : {}">{{ modelTitle }}</div>
            <div :class="brand == 'COTTI' ? 'Special_btn_rqyl' : 'Special_btn_rqyl-tc'" @click="modelShow = false">
              <div>{{ modelBtnStr }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="Special_popup" :style="{ display: modelSuccessShow ? 'block' : 'none' }">
        <div class="box" :class="brand === 'COTTI' ? 'bg' : ''">
          <div v-if="brand === '茶猫'" class="bg-tc-title"></div>
          <div :class="brand == 'COTTI' ? 'bg-cotti' : 'bg1-tc' ">
            <div class="Special_title" :style="brand == 'COTTI' ? {marginTop: '154px'} : {}">{{ modelSuccessTitle }}</div>
            <div :class="brand == 'COTTI' ? 'Special_btn_rqyl' : 'Special_btn_rqyl-tc'" @click="modelSuccessShow = false">
              <div>{{ modelSuccessBtnStr }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="Special_popup" :style="{ display: twoBtnModelShow ? 'block' : 'none' }">
        <div class="box bg" :class="brand === 'COTTI' ? 'bg' : ''">
          <div v-if="brand === '茶猫'" class="bg-tc-title"></div>
          <div :class="brand == 'COTTI' ? 'bg-cotti' : 'bg1-tc' ">
            <div class="Special_title" :style="brand == 'COTTI' ? {marginTop: '164px'} : {}">{{ twoBtnModeTitle }}</div>
            <div :class="brand == 'COTTI' ? 'Special_btn' : 'Special_btn_tc'">
            <div @click="leftClick">{{ twoBtnModeBtnStr[0] }}</div>
            <div @click="rightClick">{{ twoBtnModeBtnStr[1] }}</div>
          </div>
          </div>
        </div>
      </div>
      <div class="Special_popup" :style="{ display: ispopup ? 'block' : 'none' }">
        <div class="box " :class="brand === 'COTTI' ? 'bg' : ''">
          <div v-if="brand === '茶猫'" class="bg-tc-title"></div>
          <div :class="brand == 'COTTI' ? 'bg-cotti' : 'bg1-tc' ">
            <div class="Special_title" :style="brand == 'COTTI' ? {'margin-top': '164px'} : {'margin-top': '1px'}">加入{{ brand }}「福利社群」后才可领取哦～</div>
            <div :class="brand == 'COTTI' ? 'Special_btn' : 'Special_btn_tc'">
            <div @click="popup_del">取消</div>
            <div @click="goCommunity">立即加入</div>
          </div>
          </div>
        </div>
      </div>
      <div class="Special_popup" :style="{ display: openRule ? 'block' : 'none' }">
        <div class="box">
          <div :class="brand == 'COTTI' ? 'rule_top' : 'rule_teacat_top'"></div>
          <div :class="brand == 'COTTI' ? 'bg1' : 'bg1-tc'">
            <div v-if="brand == 'COTTI'" class="Special_content_bg"></div>
            <div class="Special_content_ly">
              <div class="Special_content" v-html="contentFormatter"></div>
            </div>
          </div>
          <img class="icon-close" src="../../assets/ticket/close-icon.png" @click.stop="doCloseRule">
        </div>
      </div>
      <div class="Special_popup" :style="{ display: isGroupGift ? 'block' : 'none' }">
        <div class="box" :class="brand === 'COTTI' ? 'bg' : ''">
          <div v-if="brand === '茶猫'" class="bg-tc-title"></div>
          <div v-if="brand === '茶猫'" class="bg1-tc">
             <div class="Special_title" style="margin-top: 30px;">{{ groupGiftTitle }}</div>
            <div class="Special_btn_rqyl-tc" @click="groupGiftClick">
              我知道了
              <div v-if="goApplet_1" style="position: absolute; width: 100%; height: 100%; top: 0">
                <wx-open-launch-weapp :username="originalAppId" path="pages/index/index"
                  style="width: 100%; height: 100%; opacity: 0; display: block">
                  <script type="text/wxtag-template">
                    <div>打开{{ brandName }}小程序</div>
                    <div>打开{{ brandName }}小程序</div>
                    <div>打开{{ brandName }}小程序</div>
                  </script>
                </wx-open-launch-weapp>
              </div>
            </div>
          </div>
          <div v-if="brand === 'COTTI'" class="Special_title" style="margin-top: 174px;">{{ groupGiftTitle }}</div>
            <div v-if="brand === 'COTTI'" class="Special_btn_rqyl" @click="groupGiftClick">
              我知道了
              <div v-if="goApplet_1" style="position: absolute; width: 100%; height: 100%; top: 0">
                <wx-open-launch-weapp :username="originalAppId" path="pages/index/index"
                  style="width: 100%; height: 100%; opacity: 0; display: block">
                  <script type="text/wxtag-template">
                    <div>打开{{ brandName }}小程序</div>
                    <div>打开{{ brandName }}小程序</div>
                    <div>打开{{ brandName }}小程序</div>
                  </script>
                </wx-open-launch-weapp>
              </div>
            </div>
          </div>
      </div>
      </div>
    <div v-else-if="!isLoading && (scanQrCodeStatusCode === 27 || scanQrCodeStatusCode === 37 || scanQrCodeStatusCode === 38 || scanQrCodeStatusCode === 39)">
      <QueryInfo :mode="scanQrCodeStatus" :linkTerminal="linkTerminal"></QueryInfo>
    </div>
  </div>
</template>

<script>
import weixinMixin from "../../mixins/wexin-mixin";
import { isPhone } from "../../utils/validate";
import {
  getCustomerSmsCodeOL,
  marketingShareH5Act,
  marketingGetH5Activity,
  marketingReceiveRewardH5,
  getCustomerCheckSmsCodeH5,
  getNearByShop,
  getCouponRecord,
  } from "../../api";
import wx from "weixin-js-sdk";
import { isWeixin, isAndroid, isIOS, isCottiApp } from "@/utils";
import { getWeChatScheme, getAdvertiseApi } from "../../api";
import {launchApp} from '../../utils/index';
import shopItem from './components/shop-item.vue';
import { Base64 } from 'js-base64'
import CouponRecord from './components/coupon-record.vue';
import QueryInfo from '../redirect/components/query-info.vue'

export default {
  components: {shopItem, CouponRecord,QueryInfo},
  name: "Ticket",
  mixins: [weixinMixin],
  computed: {
    contentFormatter() {
      if (!this.activityData.activityDesc) return '';
      return this.activityData.activityDesc.replace(/\n/g, '<br/>');
    }
  },
  data() {
    return {
      brand: this.$config.env.VUE_APP_BRAND,
      brandName: 'Cotti',
      activityLost: false,
      show: true,
      scanQrCodeStatus: 'NOT_FOUND',//扫码之后的状态 37:QRCODE_INVALID: 二维码已失效，请重新扫码  38:抱歉，活动仅限扫码参与'
      scanQrCodeStatusCode: 0,//扫码之后的状态 37:QRCODE_INVALID: 二维码已失效，请重新扫码  38:抱歉，活动仅限扫码参与'
      mobile: null,
      smsCode: null,
      smsCodeMax: 6,
      codeTypeData: undefined,
      sendBtnText: "获取验证码",
      isSmsSend: false,
      counter: 60,
      shareData: null,
      activityData: {},
      comefrom: null,
      openId: null,
      utmSource: '',
      channelType: '',
      phone: '',
      isReceived: false,
      isReceivedInitial: false, //从活动详情获取的初始
      isReceivedInitials: false,
      todayReceived: false, // 今日是否已领取
      isLoading: true,
      openTIme: false,
      // 是否跳转app
      goApp: false,
      // 是否在app中
      isInAndroid: false,
      isInIos: false,
      // 是否跳转小程序
      goApplet: false,
      goApplet_1: false,
      // 跳转链接
      appletUrl: "",
      // 判断是否是微信平台
      isWeixinPlatform: false,
      // 判断是否是小程序中
      isInMiniApp: false,
      ispopup: false, // false
      activityNo: "",
      isSupport: true,
      // 领券按钮是否可点击
      isTick: true,
      // 入群有礼弹窗状态
      isGroupGift: false,
      // 入群有礼弹窗标题
      groupGiftTitle: "",
      openRule: false,
      modelShow: false,
      modelTitle: '',
      modelBtnStr: '',
      twoBtnModelShow: false,
      twoBtnModeTitle: '',
      twoBtnModeBtnStr: ['', ''],
      activityEnded: false,
      platform: '',
      unReceiveCoupon: false,    // 是否领过券 false没领过 true领过
      /// 链接商配置的终端类型（营销后台配置）  1、小程序 2、h5 3、APP
      linkTerminal: null,
      modelSuccessShow: false,
      modelSuccessTitle: '',
      modelSuccessBtnStr: '',
      activityNotStart: false,
      agree: '',
      agreeFlag: false,
      code: null,
      walkDistanceRange: 0,
      borderLetter: null,
      markTypeDesList: [],
      prizeCouponList: [],
      shopMdCode: '',   // 门店code
      launchCode: '',   //加密活动编号
      popTitle: '',  //附近门店活动标题
      copyWriting: '',  //附近门店活动说明
      frontContentShowResult: {},
      location: {
        latitude : null, //纬度
        longitude: null //经度
      },
      couponRecordList: [],
      enableStatus: false, //是否开启附近门店组件
      noReceived: false,
      couponList: [],
      citycode: null,
      nearbyShopList: [],
      input_focus: true,
      isCouponRecord: false,
      openEnvelope: false,
      closeEnvelope: false,
      memberId: null,
      closeIcon: false,
      couponName: '',
      text: '哎呀，不错呦！',
      receiveContent: '',
      btnDisable: false,
      poi: false,
      token: '',
      advertiseUrl: '',
      randomPrize: 0, //是否随机奖品
      loading: true,
      isErr: false,
      blackbox: ''
    };
  },
  filters: {
    pwdCard(value) {
      if (isPhone(value)) {
        const start = value.slice(0, 3);
        const end = value.slice(-4);
        let strs = value;
        strs = strs.replace(/./g, "*");
        const newStr = start + "" + strs.slice(3, -4) + "" + end;
        return newStr;
      } else {
        return "****";
      }
    }
  },
  created () {
    var kuaishouScript = document.createElement('script')
    
    kuaishouScript.type = "text/javascript"
    kuaishouScript.text =`(function (root) {    var ksscript = document.createElement('script');    ksscript.setAttribute('charset', 'utf-8');    ksscript.src = '//p1-yx.adkwai.com/udata/pkg/ks-ad-trace-sdk/ks-trace.3.2.0.min.js';    var s = document.getElementsByTagName('script')[0];    s.parentNode.insertBefore(ksscript, s);})(window);`
    document.head.appendChild(kuaishouScript);
    this.launchCode = this.$route.query?.launchCode;
    var tongdunScript = document.createElement('script');
    tongdunScript.type = "text/javascript"
    if (process.env.VUE_APP_ENV === 'prod' ) {
      tongdunScript.text = `(function(){
        window._fmOpt = {
          partner: 'cotticoffee',
          appName: 'cotticoffee_h5',
          success: function(data) {
            window.blackbox = data
          }
        };
        var fm = document.createElement('script'); 
        fm.type = 'text/javascript'; fm.async = true;
        fm.src = 'https://static.trustdecision.com/tdfp/cn/7fa1350e97bf428376d94c6dba4103cc/fm.js' + '?t=' + (new Date().getTime()/3600000).toFixed(0);
        var s = document.getElementsByTagName('script')[0]; 
        s.parentNode.insertBefore(fm, s);
      })();`
    } else {
      tongdunScript.text = `(function(){
        window._fmOpt = {
          partner: 'cotticoffee',
          appName: 'cotticoffee_test',
          success: function(data) {
            window.blackbox = data
          }
        };
        var fm = document.createElement('script'); 
        fm.type = 'text/javascript'; fm.async = true;
        fm.src = 'https://static.trustdecision.com/tdfp/cn/7fa1350e97bf428376d94c6dba4103cc/fm.js' + '?t=' + (new Date().getTime()/3600000).toFixed(0);
        var s = document.getElementsByTagName('script')[0]; 
        s.parentNode.insertBefore(fm, s);
      })();`
    }
    document.head.appendChild(tongdunScript);
    
    // this.isErr = true
  },
  async mounted() {
    this.brandName = this.brand === 'COTTI' ? 'Cotti' : '茶猫'
    this.isWeixinPlatform = isWeixin();
    this.isInAndroid = isAndroid();
    this.isInIos = isIOS()
    // this.hanglePageInit()
    this.isInMiniApp = await this.isMiniProgram()
    const mmm = this.$route.query.mmm;
    this.linkTerminal = this.$route.query.a;
    this.isCouponRecord = this.$route.query?.requiredUserInfo;
   

    if (Number(this.linkTerminal) === 3 || Number(this.linkTerminal) === 4) {
      if (mmm && mmm.includes("OL")) {
        this.mobile = mmm.replace('OL', '');
      }
    }
    if (this.$route.query?.u_t) {
        this.token = this.$route.query?.u_t
    } else {
      this.token = ''
    }
    this.goApplet_1 = this.isWeixinPlatform && !this.isInMiniApp;
  },
  methods: {
      async getAmap(){
        const that = this;
        await AMap.plugin("AMap.Geolocation", () => {
          var geolocation = new AMap.Geolocation({
            // 是否使用高精度定位，默认：true
            enableHighAccuracy: true,
            //是否使用安卓定位sdk用来进行定位，需要安卓端sdk配合
            useNative: true,
            // 设置定位超时时间，默认：无穷大
            timeout: 10000,
            needAddress : true,
          });

          geolocation.getCurrentPosition((status, result) => {  //获取用户当前的精确位置
            if (status == "complete") {
              let data = result.addressComponent
              console.log(data, '定位信息')
              //重点：设置了needAddress属性 定位返回的信息回包含addressComponent对象，里面返回的内容跟regeo请求返回addressComponent 对象一致。
              if (data.adcode) {
                that.citycode = Number(data.adcode)
                that.location.latitude = result.position.lat.toString()
                that.location.longitude = result.position.lng.toString()
                that.getLocation()
              }
            }
          })
        })
        // that.getLocation()
      },
      async getAdButton (code) {
      if (this.brand === 'COTTI') {
        const {data} = await getAdvertiseApi({code: code || 'cotti-mkt-getCoupons-longTail'})
        this.advertiseUrl = data[0]?.url || ''
      } else {
        const {data} = await getAdvertiseApi({code: code || 'teacat-mkt-getCoupons-longTail'})
        this.advertiseUrl = data[0]?.url || ''
      }
    },
      getLocation () {
        if (this.couponList.length > 0) {
          getNearByShop({
          memberId: this.memberId,
          cityMdCode: this.citycode,
          selectType: 1,
          couponList: this.couponList,
          latitude: this.location.latitude || null, // 39.16142605251736 || 
          longitude: this.location.longitude || null, // 117.39025661892362 || 
          activityNo: this.activityNo
        }).then((res) => {
          if (res.code == 200) {
            this.popTitle = res.data.popTitle
            this.copyWriting = res.data.copyWriting
          if (res.data.shopListResults !== null) {
            this.nearbyShopList = res.data.shopListResults
          }
        }
        })
        }
      },

    async hanglePageInit(openId) {
      this.openId = openId || null;
      const comefrom = this.$route.query.comefrom;
      const activityNo = this.$route.query?.activityNo || '';
      this.utmSource = this.$route.query.utm_source;
      this.channelType = this.$route.query.channelType;
      this.launchCode = this.$route.query?.launchCode;
    

      this.linkTerminal = this.$route.query.a;
      if (!activityNo && (!this.utmSource && !this.launchCode)) {
        return this.$toast({ message: "URL缺少参数" });
      }
      this.comefrom = comefrom || '';
      // this.isInMiniApp = await this.isMiniProgram()
      this.activityNo = activityNo;
      if (window.blackbox) {
        this.blackbox = window.blackbox
      }
       const poi = this.$route.query?.poi;
       if (this.$route.query?.poi || window.location.href.includes('poi')) {
         this.poi = true
       } else {
         this.poi = false
       }
      if (poi && poi !== "''") {
        if (poi.indexOf(',') !== -1) {
          const poiList = poi.split(',')
          this.location.longitude = poiList[0].toString()
          this.location.latitude = poiList[1].toString()
          this.citycode = poiList[2]
          this.shopCode = poiList[3]
        }
      }
      if (this.$route.query?.u_t) {
        this.token = this.$route.query?.u_t
      } else {
        this.token = ''
      }

      // gdt('track', 'VIEW_CONTENT', {'activityNo': this.activityNo});//浏览内容，这写页面加载的地方。
      try {
        if (this.$route.query?.u_t) {
          this.token = this.$route.query?.u_t
        } else {
          this.token = ''
        }
        const mmm = this.$route.query.mmm;
        if (Number(this.linkTerminal) === 3 || Number(this.linkTerminal) === 4) {
          if (mmm && mmm.includes("OL")) {
            this.mobile = mmm.replace('OL', '');
          }
        }
        this.isLoading = true;
        this.$toast.loading({ message: "加载中...", forbidClick: true, duration: 100 });
        this.marketingShareH5ActRequest();
        await this.marketingGetH5ActivityRequest(true);
        this.isLoading = false;
        // this.$toast.clear();
      } catch (err) {
        this.isLoading = false;
        // this.$toast.clear();
      }
      if (this.activityData.participationDetails == 1) {
        this.getCouponRecordList()
      }
    },

    async getCouponRecordList () {
      const res = await getCouponRecord({
         activityNo: this.activityNo,
         memberId: this.memberId,
         couponShowName: this.couponName
        })
      if (res.code == 200 && res.data !== null) {
        this.couponRecordList = res.data
      }
    },

    async marketingShareH5ActRequest() {
      const res = await marketingShareH5Act({ activityNo: this.activityNo });
      if (res.code === 200) {
        if (res.busCode === "1") {
          this.shareData = res.data;
        } else {
          this.$toast({ message: res.busMessage });
        }
      } else {
        this.$toast({ message: res.message });
      }

    },

    openEnvelopeEvent () {
      if ((this.phone === '' || this.phone == null) && Number(this.linkTerminal) !== 2 && Number(this.linkTerminal) !== 4) {
        this.toPage('packages/common/login/index')
      } else if ((Number(this.linkTerminal) !== 2) && (this.phone === '' || this.phone == null) && (this.smsCode === '' || this.smsCode == null)) {
         this.$toast({ message: "请先登录后领取" });
      }
      else {
        if (Number(this.linkTerminal) === 2 || Number(this.linkTerminal) === 4) {
          this.handleSubmitAction()
        } else {
          this.handleRecieveAction()
        }
      }
    },
    changeImg() {
      if (this.activityData.receivingPublicityImg && this.activityData.receivingPublicityImg.url) {
        this.openEnvelope = true
        this.btnDisable = true
        setTimeout(()=> {
          this.closeEnvelope = true
          this.btnDisable = false
        // this.$toast({ message: "领券成功" });
        },2000)
      } else {
        this.closeEnvelope = true
        this.btnDisable = false
      }
    },

    afterCoupon () {
      this.receiveContent = '啊哦～'
      this.couponName = '空空如也' // 失败的文案
      this.closeEnvelope = true
      this.btnDisable = false
    },
    getShopMdCode () {
      let shopMdCode = null;
      const poi = this.$route.query.poi || null
      if (poi && poi !== "''") {
        if (poi.indexOf(',') !== -1) {
          const poiList = poi.split(',')
          shopMdCode = poiList?.[3]
        }
      } else if (isCottiApp()) {
        shopMdCode = this.$route.query.shopMdCode || null
      } 
      return shopMdCode
    },

    async marketingGetH5ActivityRequest(isInit) {
      try {
        const res = await marketingGetH5Activity({
        activityNo: this.activityNo,
        openid: this.openId,
        mobile: this.phone || this.mobile,
        linkTerminal: Number(this.linkTerminal),
        launchCode: this.launchCode,
        channelType: this.channelType,
        utmSource: this.utmSource,
        shopMdCode: this.getShopMdCode(),
      });
      if (res.code === 200) {
        // const { title }= res.data
        try {
          document.title = res.data.title;
        } catch (e) {
          console.log(e);
        }
        if (Number(this.linkTerminal) === 4) {
          try {
            AlipayJSBridge.call('setTitle', { title: res.data.title });
          } catch(e) {
            console.log(e)
          }
        }

        if (Number(this.linkTerminal) === 3) {
          try {
            var data = `{"title":"${res.data.title}"}`;
            TitleChange.postMessage(data);
          } catch(e) {
            console.log(e)
          }
        }
        this.unReceiveCoupon = res.data?.unReceiveCoupon
        if(res.data?.surroundingShopResult) {
          this.enableStatus = res.data.surroundingShopResult?.enableStatus
        }
        if (res.busCode === "1") {
          this.loading = false
          //通过判断 扫码之后的状态 37:QRCODE_INVALID: 二维码已失效，请重新扫码  38: QRCODE_ONLY 抱歉，活动仅限扫码参与' 显示
          // 27\39 门店不支持活动
          // res.data.status = 27
          if (res.data.status === 27 || res.data.status === 37 || res.data.status === 38 ) {
            this.showScanQrCodeStatus(res.data.status)
            return;
          }

          this.couponList = []
          if (res.data?.randomPrize) {
            this.randomPrize = res.data.randomPrize
          }
          if (res.data?.frontContentShowResult && res.data.status !== 9001) {
            this.frontContentShowResult = res.data.frontContentShowResult
          }
           if (res.data?.prizeName) {
                this.couponName = res.data.prizeName
              } else {
                this.couponName = res.data.couponName
              }
          if (res.data?.prizeCouponList) {
            this.prizeCouponList = res.data.prizeCouponList
            this.afterCoupon()
            this.couponList = []
            this.prizeCouponList.forEach((item, index) => {
              this.couponList.push(item.couponNo)
              })
          }
         
          if (res.data?.memberId) {
            this.memberId = res.data.memberId
             // 关闭埋点 加载过慢
            // this.$sensors.login(res.data.memberId);
          }
          this.activityData = res.data;
          this.phone = res.data?.mobile || this.phone;

          if (res.data.status === 1) {
            console.log("请求成功");
          }
          if (res.data.status === 2) {
            this.isReceived = true
          }
          
          if (res.data.status === 10) {
            this.isReceived = true;
            this.todayReceived = true
          }
          if (res.data.status == 9001) {
            this.isReceived = false
            this.$toast({ message: '当前门店暂不支持活动' });
          } else if (
            res.data.status === 9 ||
            res.data.status === 20 ||
            res.data.status === 22
          ) {
            this.isReceived = true;
            this.isReceivedInitial = true
            this.isReceivedInitials = true
          }else if(res.data.status === 4 || res.data.status === 3 || res.data.status === 31 || res.data.status >= 29 ) {
            this.isReceived = true
            // this.activityEnded = true
          }  else if (res.data.status === 5 || res.data.status === 25) {
            this.activityLost = true
            // this.modelTitle = res.data.message
            // this.modelBtnStr = '我知道了'
            // this.modelShow = true
          } else if (res.data.status === 8) {
            if (this.isInMiniApp) {
              this.activityEnded = true
            }
            if (this.frontContentShowResult && this.frontContentShowResult.contentShowAfter !== null ) {
              this.isReceived = true
            } 
            //  this.$toast({ message: res.data.message });
          } else if (res.data.status === 24) {
            this.isReceived = true
            if (this.isInMiniApp) {
              this.twoBtnModeTitle = '您已参与过当前系列活动 \n 感谢您对 Cotti 的关注'
              this.twoBtnModelShow = true
              this.twoBtnModeBtnStr[0] = '我知道了'
              this.twoBtnModeBtnStr[1] = '去喝一杯'
            } else {
              this.modelTitle = "您已参与过当前系列活动 \n 感谢您对 Cotti 的关注"
              this.modelBtnStr = '我知道了'
              this.modelShow = true
            }
          } else if (res.data.status === 26) {
            this.isReceived = true
            this.isReceivedInitial = true
          } else if (res.data.status === 7 || res.data.status === 6 || res.data.status === 28) {
            this.isReceived = false
            this.isReceivedInitial = false
            this.noReceived = true
          }

          if (isInit) {
            const isHasJumpLink = !!this.activityData?.receiveRewardComponent?.jumpLink
            this.h5CouponLandingPageView({
              activity_id: this.activityNo,
              wx_openid: this.openId,
              phone_number: this.activityData.mobile,
              is_received_new: this.isReceived ? "是" : "否",
              is_config_href_url_new: isHasJumpLink ? "是" : "否",
            });
          }
          this.handleShareAction();

        } else {
          this.loading = false
          this.activityLost = true
          this.$toast({ message: res.busMessage });
        }
        if (!this.activityData?.receiveRewardComponent?.jumpLink?.includes("http")) {
          if (this.isWeixinPlatform) {
            if (!this.isInMiniApp) {
              this.goApplet = true;
              this.appletUrl = this.activityData?.receiveRewardComponent?.jumpLink;
            }
          }
        }
      } else if (res.code === 429) {
        this.$toast({ message: "前方活动火爆，请重试!" });
      } else {
        this.$toast({ message: res.message });
      }
      } catch (err) {
        this.isErr = true
      }
      this.getAdButton(this.frontContentShowResult?.fixedPositionParam?.positionCode)
       if (this.activityData.participationDetails == 1) {
        this.getCouponRecordList()
      }
    },

    //通过判断 扫码之后的状态 37:QRCODE_ONLY 抱歉，活动仅限扫码参与' 显示   38: QRCODE_INVALID: 二维码已失效，请重新扫码
    showScanQrCodeStatus(status) {
      this.scanQrCodeStatusCode = status
      if (status === 27) {
        this.scanQrCodeStatus = 'CHOOSE_SHOP';
      } else if (status === 37) {
        this.scanQrCodeStatus = 'QRCODE_ONLY';
      } else if (status === 38) {
        this.scanQrCodeStatus = 'QRCODE_INVALID';
      } else if (status === 39) {
        this.scanQrCodeStatus = 'SHOP_INVALID';
      }

    },

    toPrivacy () {
      this.$router.push({path: '/privacy'})
    },

    toService () {
       this.$router.push({path: '/service'})
    },

    isAgree () {
      if (this.agreeFlag) {
        this.agree = ''
      }
      this.agreeFlag = true
    },

    changeAgree () {
      this.agreeFlag = false

    },
    showOffwork(e) {
      this.customerServiceCase = e
      this.$refs.offwork.show()
    },

    toPage(url) {
      if (this.isInMiniApp) {
        wx.miniProgram.navigateTo({
        url: `/${url}`,
      })
      } else if (Number(this.linkTerminal) === 3) {
        try {
            const data = ''
            NavigationLogin.postMessage(data)
          } catch (e) {
            console.warn('NavigationLogin is error')
            console.warn(e)
          }
      }
    },

    async marketingReceiveRewardH5Request(telephone) {
      try {
        let res = await window?._fmOpt?.getinfo()
        if(res) {
          this.blackbox = res
        }
      } catch(e) {
        if (window.blackbox) {
          this.blackbox = window.blackbox
        }
      }
      this.$toast.loading({ message: "加载中...", forbidClick: true, duration: 100 });
      marketingReceiveRewardH5({
        activityNo: this.activityNo,
        mobile: telephone,
        comeFrom: this.comefrom,
        launchCode: this.launchCode,
        channelType: this.channelType,
        utmSource: this.utmSource,
        openid: this.openId,
        blackBox: this.blackbox,
        shopMdCode: this.getShopMdCode(),
      }).then((res) => {
        if (res.code === 200) {
          if (res.busCode === "1") {
            if (res.data.status === 9001) {
              this.isTick = true;
              this.$toast({ message: '当前门店暂不支持活动' });
              return;
            }
            if (res.data.status === 39) {
              this.isSupport = false;
              return;
            }
            //通过判断 扫码之后的状态 37:QRCODE_INVALID: 二维码已失效，请重新扫码  38: QRCODE_ONLY 抱歉，活动仅限扫码参与' 显示
            if (res.data.status === 37 || res.data.status === 38 ) {
              this.showScanQrCodeStatus(res.data.status);
              return;
            }

            this.unReceiveCoupon = res.data.unReceiveCoupon
            // this.enableStatus = res.data.surroundingShopResult?.enableStatus
             if (res.data.frontContentShowResult) {
              this.frontContentShowResult = res.data.frontContentShowResult
              }
              if (res.data.prizeName) {
                this.couponName = res.data.prizeName
              } else {
                this.couponName = res.data.couponName
              }
              if (res.data.receiveContent) {
                this.receiveContent= res.data.receiveContent
              }
              this.couponList = []
              if (res.data.prizeCouponResultList) {
                this.couponList = []
                this.prizeCouponList = res.data.prizeCouponResultList
                this.couponList = []
                this.prizeCouponList.forEach((item, index) => {
                  this.couponList.push(item.couponNo)
                })
              }
              if (this.enableStatus == 1 && (Number(this.linkTerminal) === 2 || Number(this.linkTerminal) === 4)) {
                 this.getAmap()
                //  this.getLocation()
              } else if(this.enableStatus == 1) {
                this.getLocation()
              }
              if (res.data?.memberId) {
                this.memberId = res.data?.memberId
              }
              if (res.data.status === 1) {
              this.changeImg()
              this.unReceiveCoupon = true
              this.claimCouponClick({
                receive_result_new: "成功",
                is_member_new: res.data?.memberId ? "是" : "否",
                activity_id: this.activityNo,
                receive_result_status:res.data?.status
              });
              this.isReceived = true;
              // }
              _ks_trace.push({event: 'form', convertId: 564821, cb: function(){ console.log('Your callback function here!')}}) //快手领券埋点
              // gdt('track', 'CLAIM_OFFER', {'activityNo': this.activityNo});// 领取卡券， 这写在点击领券的地方。
              if (this.activityData.participationDetails == 1) {
              this.getCouponRecordList()
            }
            } else {
              if (res.data.status !== 0) {
                this.afterCoupon()
              }
              this.claimCouponClick({
                receive_result_new: "失败",
                is_member_new: res.data?.memberId ? "是" : "否",
                activity_id: this.activityNo,
                receive_result_status:res.data.status
              });
              if (res.data.status === 0) {
                this.isReceived = false
                this.$toast({ message: res.data.message });
              } else if (res.data.status === 10) {
                this.isReceived = true
              } else if (res.data.status === 8) {
               if (this.isInMiniApp) {
                  this.activityEnded = true
                }
                if (this.frontContentShowResult && this.frontContentShowResult.contentShowAfter !== null ) {
                  this.isReceived = true
                }
                //  this.$toast({ message: res.data.message });
              } else if (res.data.status === 9) {
                this.isReceived = true
              } else if (
                res.data.status === 16 ||
                res.data.status === 18 ||
                res.data.status === 19
              ) {
                this.ispopup = true;
              } else if(res.data.status === 40) {
                this.isReceived = true
                this.$toast({ message: '今日券已领完' });
              } else if (res.data.status === 11) {
                this.$toast({ message: res.data.message });
              } else if (res.data.status === 2 || res.data.status === 4 || res.data.status === 3 || res.data.status === 31 || res.data.status >= 28) {
                this.isReceived = true
                if (res.data.status === 4 || res.data.status === 3) {
                  this.activityData.status = res.data.status
                }
                // this.activityNotStart = true
              } else if (
                res.data.status === 5 ||
                res.data.status === 15 ||
                res.data.status === 17 ||
                res.data.status === 22 ||
                res.data.status === 23
              ) {
                this.modelTitle = res.data.message
                this.modelBtnStr = '我知道了'
                this.modelShow = true
              }
              else if(
                res.data.status === 6 ||
                res.data.status === 7) {
                  this.isReceived = false
                  this.noReceived = true
                  this.modelTitle = res.data.message
                this.modelBtnStr = '我知道了'
                this.modelShow = true
              } else if (res.data.status === 21) {
                this.groupGiftTitle = res.data.message;
                this.isGroupGift = true;
              } else if (res.data.status === 24) {
                this.isReceived = true
                if (this.isInMiniApp) {
                  this.twoBtnModeTitle = '您已参与过当前系列活动 \n 感谢您对 Cotti 的关注'
                  this.twoBtnModeBtnStr[0] = '我知道了'
                  this.twoBtnModeBtnStr[1] = '去喝一杯'
                  this.twoBtnModelShow = true
                } else {
                  this.modelTitle = "您已参与过当前系列活动 \n 感谢您对 Cotti 的关注"
                  this.modelBtnStr = '我知道了'
                  this.modelShow = true
                }
              } else if (res.data.status === -110) {
                this.toPage('packages/common/login/index')
              } else {
                this.$toast({ message: res.data.message });
                this.isReceived = true
                this.isReceivedInitial = true
              }
            }

          } else {
            this.claimCouponClick({
              receive_result_new: "失败",
              is_member_new: res.data?.memberId ? "是" : "否",
              activity_id: this.activityNo,
              receive_result_status:res.data?.status
            });
            this.$toast({ message: res.busMessage });
          }
        } else {
          this.claimCouponClick({
            receive_result_new: "失败",
            is_member_new: res.data?.memberId ? "是" : "否",
            activity_id: this.activityNo,
            receive_result_status:res.data?.status
          });
          this.$toast({ message: res.message });
        }
        this.isTick = true;
      }).catch(err => {
        this.$toast({ message: "前方活动火爆，请重试!" });
        this.isTick = true;
        return
        // this.$toast({
        //   message: err.message
        // })
      })
    },
    h5CouponLandingPageView(data) {
       // 关闭埋点 加载过慢
      // this.$sensors.track("h5_CouponLandingPage_view", data);
      // if (data.memberId) {
      //   this.$sensors.login(data.memberId);
      // }
    },

    // 此用户是否为舌尖会员（是/否）
    claimCouponClick(data) {
       // 关闭埋点 加载过慢
      // this.$sensors.track("claimCoupon_click", data);
      // if (data.memberId) {
      //   this.$sensors.login(data.memberId);
      // }
    },

    couponClaimedClick(data) {
       // 关闭埋点 加载过慢
      // this.$sensors.track("couponClaimed_click", data);
    },

    handleShareAction() {
      if (this.activityData) {
        wx.showOptionMenu();
        if (!this.activityData.share) {
          wx.hideOptionMenu();
        }
        wx.updateAppMessageShareData({
          title: this.shareData.shareTitle,
          desc: this.shareData.shareDesc,
          link: window.location.href,
          imgUrl: this.shareData.shareImg,
          success: function () {
            console.log("设置朋友成功");
          },
        });
        wx.updateTimelineShareData({
          title: this.shareData.shareTitle,
          link: window.location.href,
          imgUrl: this.shareData.shareImg,
          success: function () {
            console.log("设置朋友圈成功");
          },
        });
      }
    },
    async collectingCoupon() {
      try {
        let res = await window?._fmOpt?.getinfo()
        if(res) {
          this.blackbox = res
        }
      } catch(e) {
        if (window.blackbox) {
          this.blackbox = window.blackbox
        }
      }
      getCustomerCheckSmsCodeH5({
        mobile: this.mobile,
        smsCode: this.smsCode,
        activityNo: this.activityNo,
        comeFrom: this.comefrom,
        utmSource: this.utmSource,
        openid: this.openId,
        launchCode: this.launchCode,
        channelType:this.channelType,
        blackBox: this.blackbox,
        shopMdCode: this.getShopMdCode(),
      }).then((res) => {
        if (res.code === 200) {
          if (res.busCode === "1") {
            //通过判断 扫码之后的状态 37:QRCODE_INVALID: 二维码已失效，请重新扫码  38: QRCODE_ONLY 抱歉，活动仅限扫码参与' 显示
            if (res.data.status === 37 || res.data.status === 38 ) {
              this.showScanQrCodeStatus(res.data.status);
              return;
            }

            this.unReceiveCoupon = res.data.unReceiveCoupon
             if (res.data.frontContentShowResult) {
              this.frontContentShowResult = res.data.frontContentShowResult
              this.unReceiveCoupon = res.data.unReceiveCoupon
              }
              this.couponList = []
              if (res.data.prizeCouponResultList) {
                this.prizeCouponList = res.data.prizeCouponResultList
                this.couponList = []
                this.prizeCouponList.forEach((item, index) => {
                  this.couponList.push(item.couponNo)
                })
              }
              if (res.data.memberId) {
                this.memberId = res.data.memberId
                // 关闭埋点 加载过慢
                // this.$sensors.login(res.data.memberId);
              }
              if (res.data.prizeName) {
                this.couponName = res.data.prizeName
              } else {
                this.couponName = res.data.couponName
              }
               if (res.data.receiveContent) {
                this.receiveContent= res.data.receiveContent
              }

              if (this.enableStatus == 1 && (Number(this.linkTerminal) === 2 || Number(this.linkTerminal) === 4)) {
                 this.getAmap()
                //  this.getLocation()
              } else if(this.enableStatus == 1) {
                this.getLocation()
              }
              if (res.data.status === 1) {
              this.unReceiveCoupon = true
              this.changeImg()
              this.claimCouponClick({
                receive_result_new: "成功",
                is_member_new: res.data?.memberId ? "是" : "否",
                activity_id: this.activityNo,
                receive_result_status:res.data?.status
              });
              this.isReceived = true;
              _ks_trace.push({event: 'wechat_copy', convertId: 564516, cb: function(){    console.log('Your callback function here!')}}) //快手领券埋点
              // gdt('track', 'CLAIM_OFFER', {'activityNo': this.activityNo});// 领取卡券， 这写在点击领券的地方。
              if (this.activityData.participationDetails == 1) {
                this.getCouponRecordList()
              }
            } else {
              if (res.data.status !== 0) {
                this.afterCoupon()
              }
              this.claimCouponClick({
                receive_result_new: "失败",
                is_member_new: res.data?.memberId ? "是" : "否",
                activity_id: this.activityNo,
                receive_result_status:res.data?.status
              });
              if (res.data.status === 0) {
                this.$toast({ message: res.data.message });
              } else if (res.data.status === 10) {
                this.isReceived = true
              } else if (res.data.status === 8) {
                if (this.isInMiniApp) {
                  this.activityEnded = true
                }
                if (this.frontContentShowResult && this.frontContentShowResult.contentShowAfter !== null ) {
                  this.isReceived = true
                }
                //  this.$toast({ message: res.data.message });
              } else if (res.data.status === 9) {
                this.modelTitle = "参与次数已到上限，感谢参与"
                this.modelBtnStr = '我知道了'
                this.modelShow = true
                this.isReceived = true;
                this.phone = this.mobile
                this.isReceivedInitial = true
                this.isReceivedInitials = true
              } else if (
                res.data.status === 16 ||
                res.data.status === 18 ||
                res.data.status === 19
              ) {
                this.ispopup = true;
              } else if(res.data.status === 40) {
                this.isReceived = true
                this.$toast({ message: '今日券已领完' });
              } else if (res.data.status === 11) {
               this.$toast({ message: res.data.message });
              } else if (res.data.status === 2 || res.data.status === 4 || res.data.status === 3 || res.data.status === 31 || res.data.status >= 28 ) {
                this.isReceived = true
                if (res.data.status === 4 || res.data.status === 3) {
                  this.activityData.status = res.data.status
                }
              } else if (
                res.data.status === 5 ||
                res.data.status === 15 ||
                res.data.status === 17 ||
                res.data.status === 22 ||
                res.data.status === 23
              ) {
                this.modelTitle = res.data.message
                this.modelBtnStr = '我知道了'
                this.modelShow = true
              } else if(
                res.data.status === 6 ||
                res.data.status === 7) {
                  this.isReceived = false
                  this.noReceived = true
                  this.modelTitle = res.data.message
                this.modelBtnStr = '我知道了'
                this.modelShow = true
              } else if (res.data.status === 21) {
                this.groupGiftTitle = res.data.message;
                this.isGroupGift = true;
              } else if (res.data.status === 24) {
                this.isReceived = true
                if (this.isInMiniApp) {
                  this.twoBtnModeTitle = '您已参与过当前系列活动 \n 感谢您对 Cotti 的关注'
                  this.twoBtnModeBtnStr[0] = '我知道了'
                  this.twoBtnModeBtnStr[1] = '去喝一杯'
                  this.twoBtnModelShow = true
                } else {
                  this.modelTitle = "您已参与过当前系列活动 \n 感谢您对 Cotti 的关注"
                  this.modelBtnStr = '我知道了'
                  this.modelShow = true
                }
              } else {
                this.$toast({ message: res.data.message });
                this.isReceived = true
                this.isReceivedInitial = true
              }
            }

          } else {
            this.claimCouponClick({
              receive_result_new: "失败",
              is_member_new: res.data.memberId ? "是" : "否",
              activity_id: this.activityNo,
              receive_result_status:res.data.status
            });
            this.$toast({ message: res.busMessage });
          }
        } else {
          this.claimCouponClick({
            receive_result_new: "失败",
            is_member_new: res.data.memberId ? "是" : "否",
            activity_id: this.activityNo,
            receive_result_status:res.data.status
          });
          this.$toast({ message: res.message });
        }
      })
    },

    handleSubmitAction() {
      if (!this.mobile || !this.mobile.trim()) {
        return this.$toast({ message: "手机号输入不能为空" });
      }
      if (!isPhone(this.mobile)) {
        return this.$toast({ message: "请输入正确的手机号" });
      }
      if (!this.smsCode || !this.smsCode.trim()) {
        return this.$toast({ message: "验证码不能为空" });
      }

      const reg = new RegExp('[0-9]{' + this.smsCodeMax + '}')
      // if (!reg.test(this.smsCode)) {
      //   return this.$toast({ message: "请输入正确的验证码" });
      // }
      if (!this.agreeFlag) {
        return this.$toast({ message: "请阅读并勾选《用户协议》和《隐私政策》", duration: 4000 });
      }
      this.collectingCoupon();
    },
    handleRecieveAction() {
      if (this.isTick) {
        this.isTick = false;
        this.marketingReceiveRewardH5Request(this.phone);
      }
    },
    handleJumpAction(jumpLink, jumpType) {
      if (jumpLink) {
        this.couponClaimedClick({
          is_config_href_url_new: "是",
          activity_id: this.activityNo,
        });
        // 领券后按钮
        if (jumpLink?.includes("http")) {
          window.location.href = jumpLink;
        } else {
          if (this.isInMiniApp) {
            // let pathList = [
            //   "pages/index/index",
            //   "pages/purchase/index",
            //   "pages/coupon-store/index",
            //   "pages/order/index",
            //   "pages/mine/index"
            // ];
            if (jumpLink.includes('pages/') && !jumpLink.includes('?')) {
              wx.miniProgram.switchTab({
                url: `/${jumpLink}`,
                success: function (res) {
                  console.log('success res=', res)
                },
                fail: function (res) {
                  console.log('fail res=', res)
                }
              });
            } else {
              wx.miniProgram.navigateTo({
                url: `/${jumpLink}`,
                success: function (res) {
                  console.log('success res=', res)
                },
                fail: function (res) {
                  console.log('fail res=', res)
                }
              });
            }
          } else if (Number(this.linkTerminal) === 3) {
              const data = `{"path":"${jumpLink}"}`
              CottiNavigation.postMessage(data)
          }  else if (this.linkTerminal == '4' || this.linkTerminal === 4) {
            my.switchTab({
              url: `/${jumpLink}`,
              success: function (res) {
                console.log(res, '成功');
              },
              fail: function (err) {
                console.log(err);
              }
            });
          } else {
              if (jumpType == 1) {
                this.goApp = true
                this.appletUrl = jumpLink;
                this.openApp(this.appletUrl)
              } else if (jumpType == 2) {
                this.goApplet = true;
                this.appletUrl = jumpLink;
                this.openApplet(this.appletUrl)
              } else if (jumpLink == 3) {
                this.appletUrl = jumpLink
                this.onAli(this.appletUrl)
              }
            }
        }
      } else {
        this.couponClaimedClick({
          is_config_href_url_new: "否",
          activity_id: this.activityNo,
        });
      }
    },
    // 入群有礼弹窗点击事件
    groupGiftClick() {
      if (this.isInMiniApp) {
        wx.miniProgram.switchTab({
          url: 'pages/index/index'
        });
      } else {
        this.isGroupGift = false;
      }
    },
    async handleSendSmsCode() {
      if (!this.mobile || !this.mobile.trim()) {
        return this.$toast({ message: "手机号输入不能为空" });
      }
      if (!isPhone(this.mobile)) {
        return this.$toast({
          message: "请输入正确的手机号，否则无法接收验证码",
        });
      }
      try {
        let res = await window?._fmOpt?.getinfo()
        if(res) {
          this.blackbox = res
        }
      } catch(e) {
        if (window.blackbox) {
          this.blackbox = window.blackbox
        }
      }
      getCustomerSmsCodeOL({ mobile: this.mobile, blackBox: this.blackbox }).then((res) => {
        if (res.code === 200) {
          if (res.busCode === "1") {
            this.$toast({ message: "验证码已发送" });
            const { smsConfigResult, codeLength } = res.data;
            this.smsCodeMax = codeLength || 6
            if (!!smsConfigResult) {
              this.codeTypeData = {
                code: smsConfigResult?.code,
                title: smsConfigResult?.title,
                content: smsConfigResult?.content?.replace('AAA', this.mobile),
              }
            }
            this.isSmsSend = true;
            this.handleCountDown();
          } else {
            this.$toast({ message: res.busMessage });
          }
        } else {
          this.$toast({ message: res.message });
        }
      });
    },
    handleCountDown() {
      this.timer = setInterval(() => {
        this.sendBtnText = `<span>${this.counter}s</span>后重新获取`;
        this.counter--;
        if (this.counter < 0) {
          this.handleSmsReset();
        }
      }, 1000);
    },
    handleSmsReset() {
      this.isSmsSend = false;
      this.sendBtnText = "获取验证码";
      if (this.timer) {
        clearInterval(this.timer);
        this.counter = 60;
        this.timer = null;
      }
    },
    haveDecimal(str) {
      return String(str).indexOf(".") + 1;
    },
    // 判断是否是微信浏览器还是小程序环境
    isMiniProgram() {
      // wx.miniProgram.getEnv是异步，所以封装在Promise中
      return new Promise((resolve) => {
        if (this.isWeixinPlatform) {
          return wx.miniProgram.getEnv((res) => {
            if (res.miniprogram) {
              resolve(true);
            } else {
              resolve(false);
            }
          });
        }
        resolve(false);
      });
    },
    popup_del() {
      this.ispopup = false;
    },
    goCommunity() {
      this.$router.push({
        path: "/onlineqrcode",
        query: {
          codebg: "cotti-my-socialGroup-bg-banner-mp",
          codeqrcode: "cotti-my-socialGroup-banner-mp",
        },
      });
      this.ispopup = false;
    },
    signalClick() {
      this.activityEnded = false
      if (this.isInMiniApp) {
        wx.miniProgram.switchTab({
          url: '/pages/purchase/index'
        });
      }
    },
    leftClick() {
      this.twoBtnModelShow = false
    },
    rightClick() {
      if (this.isInMiniApp) {
        wx.miniProgram.switchTab({
          url: '/pages/purchase/index'
        });
      }
    },
    doOpenRule() {
      this.openRule = true
      this.stopScroll()
    },
    doCloseRule() {
      this.openRule = false
      this.canScroll()
    },
    // 广告位拉起app 小程序
    goToUrl() {
      if (Number(this.linkTerminal) === 3) {
        this.handleJumpAction(this.frontContentShowResult?.fixedPositionParam?.appUrl, '')
      } else if (this.isInMiniApp) {
         this.handleJumpAction(this.frontContentShowResult?.fixedPositionParam?.wxUrl, '')
      } else if (Number(this.linkTerminal) === 4) {
        this.handleJumpAction(this.frontContentShowResult?.fixedPositionParam?.aliUrl, '')
      }
      else {
        this.handleJumpAction(this.frontContentShowResult?.fixedPositionParam?.h5Url, this.frontContentShowResult?.fixedPositionParam?.h5UrlJumpType)
      }
    },
    // 跳转小程序
    openApplet(appletUrl) {
      try {
        const path = appletUrl.split('?')[0]
        const query = appletUrl.split('?')[1]
        const params = JSON.stringify({ path: appletUrl })
        getWeChatScheme({ path, query }).then(res => {
          if (res.data.scheme) {
            location.href = res.data.scheme;
          } else {
            this.$toast({ message: "打开小程序失败，请确认已安装微信" });
          }
        })
      }catch (e) {
        this.$toast({ message: "打开小程序失败，请确认已安装微信" });
      }
    },
     // 跳转app
    openApp(appletUrl) {
      const path = appletUrl.split('?')[0]
      const query = appletUrl.split('?')[1]
      const params = JSON.stringify({ path: appletUrl })
      launchApp('PAGES', Base64.encodeURI(params), true)
    },
    // 跳转支付宝小程序
    onAli(appletUrl) {
      let params =`alipays://platformapi/startapp?appId=2021004123660926&page=/${appletUrl}`
      window.location.href = `https://ds.alipay.com/?scheme=${params}`
    },
    getStyle(item) {
      const url = item?.buttonImgExternal?.url || ''
      const config = {
        'left': item && item.positionX / 100.0 + 'rem',
        'top': item && item.positionY / 100.0 + 'rem',
      }
      if (url) {
        config['background-image'] = `url(${url})`
      }
      return config
    }
  }
};
</script>

<style lang="scss" scoped >
$button-bg-color: #A52337;
$text-color: #D77C43;
$tip-bg-color: #CF4744;

.unsupport-wrapper {
  width: 100%;
  background: #FFFFFF;
  border-radius: 12px;
  text-align: center;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  line-height: 20px;
  padding: 16px 0;
  .unsupport-desc {
    font-weight: 500;
    font-size: 26px;
    color: #2A2A2A;
    line-height: 40px;
    margin: 8px 0;
  }
}

.scroll-hide {
  width: 100%;
  height: 100vh;
  -webkit-overflow-scrolling: touch;
  overflow-y: auto;
  position: fixed;
  position: -ms-device-fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background: var(--background-color);
}

.ticket {
  height: 100%;
  position: relative;

.vanpop {
    height: calc(100% - 88px);
  }

  .van-popup--bottom {
    border-radius: 16px 16px 0 0;

    .popup-content {
      width: 100%;
      height: calc(100% - 96px);

      .popup-tit {
        z-index: 105;
        position: fixed;
        left: 0;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 96px;
        color: var(--title-color);
        font-size: 32px;
        font-weight: bold;
        background: #FFFFFF;
        border-radius: 8px 8px 0 0;
      }

      .van-icon-cross {
        position: absolute;
        right: 20px;
        top: 30px;
        font-size: 36px;
      }
    }
  }
  .Special_popup {
    background: rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    z-index: 9999;

    .box {
      overflow: hidden;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      z-index: 10;

      .rule_top {
        width: 606px;
        height: 136px;
        background-image: url(https://cdn-arch-common-prod.cotticoffee.com/cottih5/open-rule-top-1.png);
        background-size: 100% 100%;
      }
      .rule_teacat_top {
         width: 606px;
        height: 116px;
        background-image: url('~@/assets/ticket/title-top.png');
         background-size: 100% 100%;
      }

      .Special_title {
        width: 86%;
        color: var(--coupon-toast-color);
        font-size: 32px;
        text-align: center;
        font-weight: 600;
        font-family: PingFangSC-Medium, sans-serif;
      }

      .Special_content_bg {
        width: 396px;
        height: 422px;
        // background-image: url('../../assets/ticket/open-rule-bg.png');
        background-size: 100% 100%;
        position: absolute;
        right: 0;
        bottom: 0;
        z-index: 1;
      }

      .Special_content_ly {
        width: 542px;
        max-height: 620px;
        margin-left: 12px;
        overflow-y: auto;
        z-index: 2;
      }

      .Special_content {
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: var(--coupon-toast-color);
        line-height: 40px;
        text-align: left;
        word-break: break-all;
        margin-top: 16px;
      }

      .Special_btn {
        position: absolute;
        display: flex;
        box-sizing: border-box;
        bottom: 64px;
        font-size: 32px;

        >div:nth-child(1) {
          width: 198px;
          height: 80px;
          border: 2px #cfcfcf solid;
          border-radius: 6px;
          overflow: hidden;
          background: #fff;
          line-height: 80px;
          text-align: center;
          margin-right: 24px;
          color: #868686;
        }

        >div:nth-child(2) {
          width: 320px;
          height: 80px;
          border-radius: 6px;
          overflow: hidden;
          background: var(--primary-color);
          line-height: 80px;
          text-align: center;
          color: #fff;
        }
      }


      .Special_btn_tc {
        position: absolute;
        display: flex;
        box-sizing: border-box;
        bottom: 64px;
        font-size: 32px;

        >div:nth-child(1) {
          width: 160px;
          height: 80px;
          border: 1px #2A2A2A solid;
          border-radius: 40px;
          overflow: hidden;
          background: #fff;
          line-height: 80px;
          text-align: center;
          margin-right: 24px;
          color: var(--text-color);
        }

        >div:nth-child(2) {
          width: 350px;
          height: 80px;
          border-radius: 40px;
          border: 1px #2A2A2A00 solid;
          overflow: hidden;
          background: linear-gradient(135deg, #FF883A 0%, #FF2B2B 100%);
          line-height: 80px;
          text-align: center;
          color: #fff;
        }
      }

      .Special_btn_singal {
        position: absolute;
        bottom: 64px;
        height: 80px;
        width: 530px;
        box-sizing: border-box;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;

        background-color: $button-bg-color;
        font-size: 32px;
        font-weight: 500;
        color: #fff;
        line-height: 44px;

        border-radius: 6px;
      }

      .Special_btn_rqyl {
        height: 80px;
        background: $button-bg-color;
        box-sizing: border-box;
        -webkit-box-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        font-size: 32px;
        font-weight: 550;
        color: #fff;
        line-height: 44px;
        margin: 55px 0;
        width: 530px;
        position: relative;
      }
      .Special_btn_rqyl-tc {
        height: 80px;
        background: linear-gradient(135deg, #FF883A 0%, #FF2B2B 100%);
        box-sizing: border-box;
        -webkit-box-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        font-size: 32px;
        font-weight: 550;
        color: #fff;
        line-height: 44px;
        margin: 85px 0 0 0;
        width: 526px;
        border-radius: 40px;
        position: relative;
      }

      .icon-close {
        margin-top: 45px;
        width: 48px;
      }
    }

    .bg {
      width: 606px;
      height: 620px;
      background: url(https://cdn-product-prod.cotticoffee.com/wechat/cotti/images/activity/activity-success.png);
      background-size: 100% auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      border-bottom-left-radius: 12px;
      border-bottom-right-radius: 12px;
    }
    .bg-tc-title {
      width: 606px;
      height: 300px;
      background: url('../../assets/ticket/tc-top.png');
      background-size: 100% auto;
    }


    .bg-cotti {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .bg1 {
      width: 606px;
      min-height: 250px;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      padding: 32px 0;
      border-bottom-left-radius: 20px;
      border-bottom-right-radius: 20px;
    }
    .bg1-tc {
      width: 606px;
      min-height: 220px;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      padding: 32px 0;
      border-bottom-left-radius: 24px;
      border-bottom-right-radius: 24px;
    }

    .activity-status {
      width: 606px;
      height: 620px;
      background-image: url(https://cdn-product-prod.cotticoffee.com/wechat/cotti/images/activity/activity-end.png);
      background-size: 100% 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .activity-status-success {
      width: 646px;
      height: 536px;
      background-image: url('../../assets/ticket/activity-status.png');
      background-size: 100% 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  .cnt-button {
    outline: none;
    background: rgba(0, 0, 0, 0);
    border: none;
    font-size: 0;
    padding: 0;
    margin: 0;

    &.radius {
      border-radius: 8px;
      overflow: hidden;
    }
  }

  .ticket-bg-img {
    width: 100%;
    position: absolute;
    top: 0;
  }
  .transition-img {
    margin-top: -176px;
    height: 320px;
  }
  .background-img {
    width: 100%;
  }
   .envelope-img {
    position:absolute;
    top: 0;
    z-index:999;
    width: 100%;
  }
  .coupon {
    z-index: 9999;
    position: absolute;
    width: 100%;
    display: flex;
    flex-direction: column;
  justify-content: center;
  align-items: center;
    // max-width: 130px;
    // left: 25%;
  }
  .coupon-name {
    width: 360px;
    height: 56px;
    font-size: 34px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: var(--text-base-color);
    line-height: 56px;
    text-shadow: 0px 4px 8px rgba(249,181,87,0.1);
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    // padding-top: 16px;

  }
   .coupon-text {
     width: 360px;
    height: 34px;
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: var(--text-base-color);
    line-height: 34px;
    text-shadow: 0px 6px 8px rgba(238,181,103,0.2);
    // margin-top: -480px;
    text-align: center;
    margin-top: -48px;
    padding-bottom: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }


  .ticket-rule {
    position: absolute;
    z-index: 1001;
    top: 32px;
    right: 32px;
    width: 164px;
    height: 56px;
    border-radius: 27px;
    background: rgba(55, 55, 55, 0.4);
    font-weight: 500;
    color: #fff;
    line-height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;

    .rule-img {
      width: 28px;
      margin-right: 10px;
    }
  }

  .ticket-single {
    box-sizing: border-box;
    background-size: cover;
    margin-bottom: 15px;
    left: 64px;
    top: 760px;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 16px;
    padding: 22px 22px 16px;

    .single-content {
      height: 176px;
      width: 658px;
      background-image: url(https://cdn-product-prod.cotticoffee.com/wechat/cotti/images/activity-single.png);
      background-size: 100% 100%;
      display: flex;

      .content-item {
        color: $text-color;
      }

      .content-item-price {
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 500;
        font-size: 40px;
        width: 228px;
        flex-direction: column;
        padding-left: 18px;

        .price-unit {
          font-size: 28px;
          font-weight: 550;
          position: relative;
          top: 5px;
        }

        .price-num {
          font-size: 44px;
          line-height: 48px;
          font-weight: 600;
        }

        .price-name {
          font-size: 28px;
        }

        .name-num {
          font-size: 20px;
          font-weight: 400;
          color: $text-color;
          line-height: 28px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .content-item-name {
        text-align: left;
        width: 290px;
        padding-left: 28px;
        display: flex;
        align-items: center;

        .name-text {
          font-size: 32px;
          font-weight: 500;
          color: $text-color;
          overflow: hidden;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          -ms-text-overflow: ellipsis;
          text-overflow: ellipsis;
        }
      }

      .content-item-type {
        position: relative;

        .type-name {
          position: absolute;
          top: 10px;
          right: -84px;
          color: #fff;
          width: 76px;
          font-size: 24px;
          font-weight: 500;
          text-align: center;
          font-family: PingFangSC-Medium, sans-serif;
          background-color: $tip-bg-color;
          padding: 10px;
          border-top-right-radius: 12px;
          border-bottom-left-radius: 12px;
        }
      }
    }
  }

  .ticket-multiple {
    box-sizing: border-box;
    margin-bottom: 15px;
    left: 64px;
    top: 250px;
    width: 702px;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 16px;
    padding: 32px 24px;

    .multiple-header {
      height: 36px;
      font-size: 26px;
      font-weight: 500;
      color: #111;
      line-height: 36px;
      text-align: center;
      margin-bottom: 24px;
    }

    .multiple-main {
      display: flex;
      justify-content: space-between;
      flex-direction: row;
      flex-wrap: wrap;
      max-height: 300px;
      overflow-y: auto;

      .multiple-content {
        background-image: url('../../assets/ticket/multiple.png');
        background-size: 100% 100%;
        width: 316px;
        height: 116px;
        display: flex;
        margin-bottom: 24px;

        .content-item {
          color: $text-color;
        }

        .content-item-type {
          position: relative;

          .type-name {
            position: absolute;
            top: 10px;
            right: -84px;
            color: #fff;
            width: 76px;
            font-size: 24px;
            font-weight: 500;
            text-align: center;
          }
        }

        .content-item-price {
          display: flex;
          justify-content: center;
          align-items: center;
          font-weight: 500;
          width: 50%;
          padding-left: 6px;
          flex-direction: column;

          .price-unit {
            font-size: 22px;
            position: relative;
            top: 2px;
          }

          .price-unit-rmb {
            font-size: 24px;
            position: relative;
            top: 3px;
          }

          .price-num {
            font-size: 36px;
            line-height: 48px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .name-num {
            height: 28px;
            font-size: 12px;
            color: $text-color;
            margin-bottom: 4px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            max-width: 130px;
          }

          .price-change-buy {
            font-size: 14px;
            font-weight: 500;
            width: 12px;
            display: inline-block;
            margin-left: 4px;
          }
        }

        .content-item-name {
          box-sizing: border-box;
          text-align: left;
          padding-left: 24px;
          padding-right: 18px;
          width: 48%;
          display: flex;
          align-items: center;

          .name-text {
            font-size: 26px;
            font-weight: 500;
            color: $text-color;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          }
        }
      }
    }
  }

  .ticket-user {
    left: 64px;
    top: 950px;
    width: 702px;
    min-height: 300px;
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.9);
    box-sizing: border-box;
    padding: 32px 28px 40px;

    .user-wrapper {
      margin-bottom: 26px;

      .radio {
        padding: 18px 0 18px 0px;
        .text {
        height: 40px;
        line-height: 40px;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: var(--title-color);
      }
      .img {
        width: 32px;
        height: 32px;
      }
      .click-text {
        color: var(--primary-color);
      }
      }

      ::v-deep .van-cell {
        padding: 18px 32px;
      }

      &.passwd-item {
        ::v-deep .van-cell {
          padding-right: 0;
        }
      }

      .van-field {
        background: #fff;
        border-radius: 8px;
        border: 1px solid var(--text-color);

        ::v-deep .van-field__control {
          font-size: 32px;
        }

        ::v-deep input::-webkit-input-placeholder {
          font-size: 28px;
        }
      }

      .button-warpper {
        min-width: 186px;
        padding: 0 20px;
        display: flex;
        flex: 1 1 auto;
        justify-content: center;
        position: relative;
        border-left: 1px solid #e5e5e5;

        .code-line {
          position: absolute;
          left: 0;
          top: 0;
          color: #e5e5e5;
        }

        .code-action {
          height: 32px;
          font-size: 28px;
          font-weight: 400;
          color: var(--text-base-color);
          line-height: 32px;
        }

        ::v-deep .code-action__disabled {
          height: 32px;
          font-size: 28px;
          font-weight: 400;
          color: var(--title-color);
          line-height: 32px;

          >span {
            padding-right: 6px;
            color: var(--text-base-color);
          }
        }
      }
    }
    .privacy {
      display:inline;
    }

    .captcha-notice {
      margin-bottom: 28px;
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: var(--text-color);
      line-height: 34px;
      text-align: justify;
      padding-top: 16px;
    }

    .user-action {
      width: 100%;
      margin-top: 14px;

      img {
        width: 100%;
      }
    }
  }

  .ticket-receive {
    left: 64px;
    top: 950px;
    width: 702px;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 16px;
    box-sizing: border-box;
    padding: 32px 48px 48px 48px;
    text-align: center;
    backdrop-filter: blur(2px);
    // box-shadow: 0px 4px 16px 2px rgba(0, 0, 0, 0.1);

    .receive-title {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 40px;
      line-height: 40px;
      margin-bottom: 16px;

      .text {
        height: 28px;
        font-size: 28px;
        font-weight: 400;
        color: var(--coupon-toast-color);
        line-height: 28px;
        white-space: nowrap;
        text-align: center;
      }
    }

    .receive-phone {
      height: 80px;
      font-size: 52px;
      font-weight: 500;
      color: #2A2A2A;
      line-height: 80px;
      margin-bottom: 16px;
    }
     .received-phone {
        height: 28px;
        font-size: 28px;
        font-weight: 400;
        color: var(--coupon-toast-color);
        line-height: 28px;
        white-space: nowrap;
        text-align: center;
    }

    .receive-action {
      padding: 0 6px;

      img {
        width: 100%;
      }
    }

  }

  .shop-receive {
    margin-top: 24px;
    width: 702px;
    background: rgba(255, 255, 255, 1);
    border-radius: 16px;
    box-sizing: border-box;
    padding: 32px 24px;
    backdrop-filter: blur(2px);
    .activity-title {
      height: 44px;
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: var(--title-color);
      line-height: 44px;
      border-radius: 16px;
    }
    .max-receive {
      // max-height: 480px;
      // height: 100%;
      overflow: auto;
      background-color: var(--background-color);
      border-radius: 16px;
      padding: 28px 24px 0 24px;
      overflow-x: hidden;
      margin-top: 32px;
      // .max-receive-list {
      //   // animation: scroll 15s linear infinite;
      //   // animation-fill-mode: forwards;
      //   // animation-direction: normal;
      //   // animation-play-state: running;
      // }
      // // .max-receive-list:hover {
      // //   animation-play-state: paused;
      // //   // margin-top: 0;
      // //   // animation: scroll-pauserd 0s linear infinite;
      // //   // height: 1000px !important;
      // //   // top: 0;
      // // }

    }
    .no-receive {
      overflow: auto;
      overflow-x: hidden;
      margin-bottom: 32px;
      .img {
        width: 160px;
        height: 160px;
        margin-left: 35%;
        margin-top: 32px;

      }
      .no-card {
        font-size: 24px;
        height: 36px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: var(--text-color);
        line-height: 36px;
        text-align: center;
        // margin-bottom: 32px;
      }
    }
    .activity-desc {
      height: 32px;
      font-size: 22px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #5E5E5E;
      line-height: 32px;
      margin: 12px 0 8px 0;
    }
    .shop-list {
      margin-top: 32px;
    }
  }

  .ticket-received {
    text-align: center;
    left: 64px;
    top: 65px;
    width: 702px;
    min-height: 300px;
    background: rgba(255, 255, 255, 0.9);
    box-sizing: border-box;
    border-radius: 16px;
    padding: 32px 24px 48px 24px;
    // box-shadow: 0 4px 16px 2px rgba(0, 0, 0, 0.1);

    .received-title {
      height: 40px;
      font-size: 28px;
      font-weight: 500;
      color: var(--coupon-toast-color);
      line-height: 40px;
      margin-bottom: 16px;
    }
    .received-new-title {
      height: 56px;
      font-size: 40px;
      font-weight: 600;
      color: #2A2A2A;
      line-height: 56px;
      margin-bottom: 16px;
    }


    .received-hint {
      height: 28px;
      font-size: 28px;
      font-weight: 600;
      color: var(--coupon-toast-color);
      line-height: 28px;
    }

    .received-bag {
      height: 80px;
      font-size: 36px;
      font-weight: 600;
      color: var(--text-base-color);
      line-height: 80px;
      margin-bottom: 16px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .received-phone {
      height: 40px;
      font-size: 28px;
      font-weight: 500;
      color: var(--coupon-toast-color);
      line-height: 40px;
      margin-bottom: 32px;
    }

    .received-action {
      padding: 0 0px;

      img {
        width: 100%;
      }
    }
    .no-received {
      position: relative;
      font-size: 0;
      margin: 0 -24px -48px -24px;
    }
  }
}
.img_box {
  position: absolute;
  top: 0;
  height: 320px;
}

.box_ticket {
  position: absolute;
  top: 0px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  flex-direction: column;
  // z-index: 9999;

  .publicity-picture {
    width: 702px;
    margin: 0 auto 32px;
    overflow: hidden;

    >img {
      width: 100%;
      height: 100%;
    }
  }
}
.error_bg{
  background: linear-gradient( 225deg, #FFFFFF 0%, #FFD5D3 100%);
}
.error_bg_tc {
  background: linear-gradient( 225deg, #FFFFFF 0%, #FBFFBE 100%);
}
.lost {
  display:flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 90vh;
  .lost-img{
    width: 280px;
    height: 240px;
  }
  .lost_title {
    font-size: 32px;
    font-weight: 600;
    color: #3A3B3C;
    line-height: 44px;
    text-align: center;
    margin-top: 24px;
  }
  .lost_text {
    margin-top: 16px;
    font-weight: 400;
    font-size: 28px;
    color: #979797;
    line-height: 40px;
  }
}
.error {
  position: absolute;
  top: 0;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: scroll;
  .is_error {
    width: 100vw;
  }
  .is_err_title {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    .is_err_img {
      width: 64px;
    }
    .is_err_text {
      font-weight: 500;
      font-size: 32px;
      color: #75270C;
      line-height: 48px;
      text-align: center;
      margin-left: 14px;
    }
    .error_text_tc {
      color: #FF5E31;
    }
  }
  .toast-title {
    font-weight: 500;
    font-size: 32px;
    color: #3A3B3C;
    line-height: 44px;
    text-align: center;
    font-style: normal;
    margin-bottom: 16px;
    margin-top: 24px;
  }
  .toast-body {
    font-weight: 500;
    font-size: 28px;
    color: #979797;
    line-height: 44px;
    text-align: center;
  }
}

.box1 {
  overflow: hidden;
  position: absolute;
  top: calc(50% - 68px);
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 10;
}

.activty-ly-end {
  width: 606px;
  height: 620px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: url(https://cdn-product-prod.cotticoffee.com/wechat/cotti/images/activity/activity-end.png) center no-repeat;
  background-size: cover;

  .share-title {
    font-size: 32px;
    font-weight: 600;
    color: var(--title-color);
    line-height: 32px;
    margin-top: 326px;
  }

  .share-content {
    height: 28px;
    font-size: 28px;
    font-weight: 400;
    color: var(--title-color);
    line-height: 28px;
    margin-top: 24px;
  }
}

.activty-ly-not-start {
  width: 606px;
  height: 620px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: url(https://cdn-product-prod.cotticoffee.com/wechat/cotti/images/activity/activity-not-start.png) center no-repeat;
  background-size: cover;

  .share-title {
    font-size: 32px;
    font-weight: 600;
    color: var(--title-color);
    line-height: 32px;
    margin-top: 336px;
  }

  .share-content {
    height: 48px;
    font-size: 28px;
    font-weight: 400;
    color: var(--title-color);
    line-height: 48px;
    margin-top: 12px;
  }
}

.bt-ly {
  width: 510px;
  background-color: $button-bg-color;
  box-shadow: 0 16px 24px -10px rgba(71, 8, 0, 0.12), 0 44px 16px -40px rgba(224, 216, 212, 0.1);
  border-radius: 6px;
  margin-bottom: 48px;
  margin-top: 52px;

  .txt {
    font-size: 32px;
    font-weight: 500;
    color: #fff;
    text-align: center;
    border: none;
    line-height: 80px;
  }
}

.clsoe-ly {
  width: 66px;
  height: 66px;
  margin: 0 auto;
  margin-top: 64px;

  .clsoe {
    width: 66px;
    height: 66px;
  }

}
 ::v-deep .van-icon {
    width: 32px;
    height: 32px;
    line-height: 40px;
    text-align: center;
   }
  ::v-deep .van-radio__label {
    margin-top: -3px !important;
}
::v-deep .van-field__control {
  caret-color: var(--text-base-color) !important;
}
::v-deep .van-cell {
    padding: 18px 24px !important;
}
::v-deep .van-field__button {
    padding-left: 8px;
    position: absolute;
    right: -18px;
    top: 8px;
}
::v-deep .mask {
    opacity: 0 !important;
}



@keyframes scroll {
  0% {
    transform: translateY(0);
  }
  10% {
    transform: translateY(0);
  }
  90% {
    transform: translateY(-100%);
  }
  100% {
    transform: translateY(-100%);
  }
}
@keyframes scroll-paused {
  // 0% {
  //   transform: translateY(0);
  // }
  // 100% {
  //   transform: translateY(0);
  // }
}

</style>
